import React, { useEffect, useState } from 'react';
import './index.scss';

export default function ItemPreview(props) {
  const [itemData, setItemData] = useState(null);

  useEffect(() => {
    if(props.itemID){
      window.cet.microservices.contentapi.content.getItemById({ itemId: props.itemID }).then(item => {
        setItemData(item);
        if(props.onItemLoad) {
          props.onItemLoad(item);
        }
      }).catch(error => {
        setItemData(null);
        if(props.onItemLoad) {
          props.onItemLoad(null);
        }
      });
    }
  }, [props.itemID]);

  const getImageUrl = (id, width, height) => {
    return id ? window.cet.microservices.contentapi.thumbnails.getImageUrl({ id, width, height }) : '';
  };

  return (
    (itemData && <article className="item__container">
      <div className="item__bannerContainer">
        <img src={getImageUrl(itemData.thumbnailId, 285, 149)} className="item__banner" alt={itemData.title}/>
      </div>
      <div className="item__content">
        <h3 className="item__title"><a href={itemData.contextURL}>{itemData.title}</a></h3>
      </div>
    </article>)
  );
};